"use strict";

var $ = require("jquery");
var uuid = require("./uuidMIT");

require("../style/general.scss");
require("../style/uim-widget.scss");
var common = require("./common");
var country = require("./country");
var MultiFactorAuthentication = require("./multi_factor_auth");
// Require `PhoneNumberFormat`.
var PNF = require('google-libphonenumber').PhoneNumberFormat;

// Get an instance of `PhoneNumberUtil`.
var phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();
var AUTH_PATH = "/sso/json/msusers/authenticate";
var pwdKeyup = true;
var confPwdKeyup = true;

function ValidUserRegistration (params) {
    this.validUserWidgetInstance = params.validUserWidgetInstance;
    this.email = params.email;
    this.environment = params.environment;
    this.apigeeKey = params.apigeeKey;
    this.token = params.token;
    this.passwordPlaceholder = params.passwordPlaceholder;
    this.passwordConfirmationPlaceholder = params.confirmPasswordPlaceholder;
    this.mobilePlcaehoder = params.mobilePlcaehoder;
    this.redirectURL = params.redirectURL;
    this.mfaEnforced = params.mfaEnforced;
    this.mfaParent = params.mfaParent;
    this.receiveLocaleWidget = params.receiveLocaleWidget;
    this.enterLocaleWidget = params.enterLocaleWidget;
    if(params.mobileNumber != null && params.mobileNumber != ''){
        var mobileNumber = phoneUtil.parse(params.mobileNumber);
        this.countryCode = phoneUtil.getRegionCodeForNumber(mobileNumber);
        this.mobileNumber = phoneUtil.getNationalSignificantNumber(mobileNumber);
    } else {
        this.countryCode = "US";
    }

    this.apiUrl = common.API_ENVIRONMENTS[this.environment] + '/pre-registration-request';
    this.baseUrl = common.SSO_ENVIRONMENTS[this.environment];
    this.proxyBaseUrl = params.proxyBaseUrl;
}

ValidUserRegistration.prototype.init = function (requestId) {
    var self = this;
    this.validUserRegParent = this.validUserWidgetInstance.validUserRegistrationParent.find(".valid-registration");
    this.clearErrorMessages();
    var passwordField = this.validUserRegParent.find("input#uim-uPassword-input");
    var confirmPasswordField = this.validUserRegParent.find("input#uim-uPasswordConfirmation-input");
    var countryCode = this.validUserRegParent.find(".country");
    country.loadCountries(countryCode);
    countryCode.val(this.countryCode).change();
    var inputMobileNumber= this.validUserRegParent.find("input#uim-uMobile-input");
    if(this.mobileNumber != 'undefined' && this.mobileNumber != null && this.mobileNumber != ''){
        inputMobileNumber.val(this.mobileNumber);
    }
    var submit = this.validUserRegParent.find("input#uim-registration-submit");
    var inputErrors = this.validUserRegParent.find("#register-errors");
    var confirmPasswordError = this.validUserRegParent.find("#reg-confirm-password-error");
    var mobileErrors = this.validUserRegParent.find("#mobile-errors");

    this.fields = {
        password: passwordField,
        confirmPassword: confirmPasswordField,
        countryCode: countryCode,
        inputMobileNumber: inputMobileNumber
    };

    $("#register-email-show")[0].innerHTML = this.email;

    if (this.mobilePlcaehoder) {
        inputMobileNumber[0].placeholder = this.mobilePlcaehoder;
    }
    if (this.passwordPlaceholder) {
        passwordField[0].placeholder = this.passwordPlaceholder;
    }
    if (this.passwordConfirmationPlaceholder) {
        confirmPasswordField[0].placeholder = this.passwordConfirmationPlaceholder;
    }

    inputMobileNumber.on("blur", function () {
        self.validatePhoneNumber(inputMobileNumber, mobileErrors, ".uim-message.invalid-mobile-input");
        self.updateSubmitState();
    });

    countryCode.on("change", function () {
        self.validatePhoneNumber(inputMobileNumber, mobileErrors, ".uim-message.invalid-mobile-input");
        self.updateSubmitState();
    });

    passwordField.on("focus", function () {
        var isEmptyPWD = self.fields.password.val().length === 0;
        if(isEmptyPWD){
            pwdKeyup = true;
            $("div#password-input-area").removeClass("error");
            common.hideElement(inputErrors.find(".uim-message.empty-password-input"));
            common.hideElement(inputErrors.find(".uim-message.maxlength"));
            common.hideElement(inputErrors.find(".uim-message.required"));
        }
    });

    passwordField.on("blur", function () {
        if(common.validateRequiredField(passwordField,inputErrors,".uim-message.empty-password-input")) {
            pwdKeyup = common.validatePassword(passwordField, inputErrors, self.email);
        } else {
            common.hideElement(inputErrors.find(".uim-message.maxlength"));
            common.hideElement(inputErrors.find(".uim-message.required"));
        }
        self.updateSubmitState();
    });

    passwordField.on("keyup", function () {
        if(!pwdKeyup){
            var isEmptyPWD = self.fields.password.val().length === 0;
            if(common.validateRequiredField(passwordField,inputErrors,".uim-message.empty-password-input")) {
                pwdKeyup = common.validatePassword(passwordField, inputErrors, self.email);
            }else if(isEmptyPWD){
                passwordField.parent().removeClass("error");
                common.hideElement(inputErrors.find(".uim-message.empty-password-input"));
                common.hideElement(inputErrors.find(".uim-message.required"));
                common.hideElement(inputErrors.find(".uim-message.maxlength"));
                //this.clearErrorMessages();
                pwdKeyup = true;
            }else {
                common.hideElement(inputErrors.find(".uim-message.maxlength"));
                common.hideElement(inputErrors.find(".uim-message.required"));
            }
            self.updateSubmitState();
        }
    });

    confirmPasswordField.on("focus", function () {
        var isEmptyCFPWD = self.fields.confirmPassword.val().length === 0;
        if(isEmptyCFPWD){
            confPwdKeyup = true;
            $("div#change-confirm-password-input-area").removeClass("error");
            common.hideElement(confirmPasswordError.find(".uim-message.password-empty-input"));
            common.hideElement(confirmPasswordError.find(".uim-message.password_match"));
        }
    });

    confirmPasswordField.on("blur", function () {
        if(common.validateRequiredField(confirmPasswordField,confirmPasswordError,".uim-message.password-empty-input")) {
            confPwdKeyup = common.validateConfirmPassword(passwordField, confirmPasswordField, confirmPasswordError);
        } else {
            common.hideElement(confirmPasswordError.find(".uim-message.password_match"));
        }
        self.updateSubmitState();
    });

    confirmPasswordField.on("keyup", function () {
        if(!confPwdKeyup){
            var isEmptyCFPWD = self.fields.confirmPassword.val().length === 0;
            if(common.validateRequiredField(confirmPasswordField,confirmPasswordError,".uim-message.password-empty-input")) {
                confPwdKeyup = common.validateConfirmPassword(passwordField, confirmPasswordField, confirmPasswordError);
            }else if(isEmptyCFPWD){
                confirmPasswordField.parent().removeClass("error");
                common.hideElement(confirmPasswordError.find(".uim-message.password_match"));
                common.hideElement(confirmPasswordError.find(".uim-message.password-empty-input"));
                confPwdKeyup = true;
            }else {
                common.hideElement(confirmPasswordError.find(".uim-message.password_match"));
            }
            self.updateSubmitState();
        }
    });

    submit.on("click enter", function (e) {
        e.preventDefault();
        self.createUser({
            username: self.email,
            password: self.fields.password.val(),
            inputMobileNumber: self.fields.inputMobileNumber.val(),
            requestId: requestId
        });
    });
};

ValidUserRegistration.prototype.resetToDefault = function () {
    this.mfaParent.hide();
    this.validUserRegParent.show();
};

ValidUserRegistration.prototype.updateSubmitState = function() {
    if(this.allFilled() && !this.checkValidationErrors()) {
        $('#uim-registration-submit').removeAttr('disabled');
    } else {
        $('#uim-registration-submit').attr("disabled", true);
    }
};

ValidUserRegistration.prototype.validatePhoneNumber = function(inputField,errorField,errorFieldId) {
    var isValid=false;
    var parsedPhoneNumber;
    if(inputField.val() != null && inputField.val() != ""){
       try
       {
           parsedPhoneNumber = phoneUtil.parse(inputField.val(),this.fields.countryCode.val());
       } catch (NumberParseException){
            inputField.parent().addClass("error");
            common.showElement(errorField.find(errorFieldId));
            return "";
       }

       isValid = phoneUtil.isValidNumber(parsedPhoneNumber);
        if(!isValid){
            inputField.parent().addClass("error");
            common.showElement(errorField.find(errorFieldId));
        } else {
            inputField.parent().removeClass("error");
            common.hideElement(errorField.find(errorFieldId));
        }
    } else {
        inputField.parent().removeClass("error");
        common.hideElement(errorField.find(errorFieldId));
    }

};

ValidUserRegistration.prototype.allFilled = function(){
    var filled = true;
    var isEmptyPassword = this.fields.password.val().length === 0;
    var isEmptyConfirmPassword = this.fields.confirmPassword.val().length === 0;

    if(isEmptyPassword || isEmptyConfirmPassword){
        filled = false;
    }
    return filled;
};

ValidUserRegistration.prototype.checkValidationErrors = function() {
    var inputErrorsElement = this.validUserRegParent.find("#register-errors");
    var confirmPasswordElement = this.validUserRegParent.find("#reg-confirm-password-error");
    var mobileErrorsElement = this.validUserRegParent.find("#mobile-errors");
    return (
        common.checkElement(inputErrorsElement.find(".uim-message.required")) ||
        common.checkElement(inputErrorsElement.find(".uim-message.maxlength")) ||
        common.checkElement(mobileErrorsElement.find(".uim-message.invalid-mobile-input")) ||
        common.checkElement(inputErrorsElement.find(".uim-message.empty-password-input")) ||
        common.checkElement(confirmPasswordElement.find(".uim-message.password_match")));
};

ValidUserRegistration.prototype.clearErrorMessages = function () {
    var inputErrorsElement = this.validUserRegParent.find("#register-errors");
    var confirmPasswordElement = this.validUserRegParent.find("#reg-confirm-password-error");

    common.hideElement(inputErrorsElement.find(".uim-message.required"));
    common.hideElement(inputErrorsElement.find(".uim-message.maxlength"));
    common.hideElement(inputErrorsElement.find(".uim-message.empty-password-input"));
    common.hideElement(confirmPasswordElement.find(".uim-message.password_match"));
};

ValidUserRegistration.prototype.showInputErrors = function (status) {
    var submitErrorsElement = this.validUserRegParent.find("#registerSubmit-errors");
    common.showElement(submitErrorsElement.find(".uim-message.unknown_server_error"));
};

ValidUserRegistration.prototype.createUser = function(params) {
    var self = this;
    var validNumber = null;
    if(params.inputMobileNumber != null && params.inputMobileNumber != ""){
        var pn = phoneUtil.parse(params.inputMobileNumber,self.fields.countryCode.val());
        validNumber = phoneUtil.format(pn,PNF.INTERNATIONAL);
    }

    var attributes = {
        password : params.password
    };
    if(validNumber != null){
        attributes.regMobileNumber = validNumber;
    }
    $.ajax({
        method: "PATCH",
        url: this.apiUrl + "/" + this.token,
        data: JSON.stringify({
            data : {
                type : "pre-registration-request" ,
                id : this.token ,
                attributes : attributes
            }
        }),
        headers : {
            ApiKey : this.apigeeKey,
            "X-API-RequestId": params.requestId
        }
    }).success(function() {
        self.submit(params);
    }).error(function(xhr) {
        self.showInputErrors(xhr.status);
    });
};

ValidUserRegistration.prototype.getUrl = function (isMFAResponse) {
    var url = this.baseUrl + AUTH_PATH;
    return isMFAResponse ? (url + "?authIndexType=service&authIndexValue=mfaService") : url;
};

ValidUserRegistration.prototype.submit = function(params, callback) {
    // IE 10 fix
    var objAppVersion = navigator.appVersion;
    var contentType = "application/json";
    if (objAppVersion.indexOf("MSIE 10.0") > -1) {
        contentType = "text/html";
    }

    var self = this;

    $.ajax({
        method: "POST",
        url: this.getUrl(params.isMFAResponse),
        xhrFields: {
            withCredentials: true
        },
        data: "",
        headers: {
            "Content-Type": contentType,
            "X-OpenAM-Username": params.username,
            "X-OpenAM-Password": params.password,
            "X-API-RequestId": params.requestId
        }
    }).success(function(data) {
        window.location.replace(self.redirectURL);
    }).error(function (response, status, error) {
        if(self.mfaEnforced){
            var mfaChallenge = response.getResponseHeader("TRANSACTION");
            if (typeof mfaChallenge === "string") {
                self.validUserRegParent.hide();
                self.mfaParent.show();
                try {
                    mfaChallenge = JSON.parse(mfaChallenge);
                } catch (err) {
                    self.showInputErrors(response.status);
                    self.errorCallback(new Error("Problem logging in"), response.status);

                    // throw error on next tick
                    setTimeout(function () {
                        throw err;
                    }, 0);
                }

                var multiFactorAuthentication = new MultiFactorAuthentication({
                    loginWidgetInstance: self,
                    mfaChallenge: mfaChallenge
                });
                return multiFactorAuthentication.init(params.requestId);
            }
            if (callback && params.isMFAResponse) {
                return callback(response, response.status, error);
            }
        }else {
            self.showInputErrors(response.status);
        }
    });
};

module.exports = ValidUserRegistration;



//////////////////
// WEBPACK FOOTER
// ./components/ui-widgets/src/js/user-validRegistration.js
// module id = 38
// module chunks = 0